import React, { useEffect } from 'react';
import { Typography } from '@fiverr-private/typography';
import { briefCreationDrawerEducationIsShown } from '../../../monitoring';
import { AppI18n } from '../../../i18n';
import { useBriefCreationContext } from '../../../context/BriefCreationContext';

export const NotSureDescription = () => {
  const { briefClassification, contextId, source, variant } = useBriefCreationContext();
  const leafClassification = briefClassification?.leaf_classification[0];

  useEffect(() => {
    briefCreationDrawerEducationIsShown({
      educationType: 'im_not_sure',
      categoryId: leafClassification?.category_id,
      subCategoryId: leafClassification?.sub_category_id,
      nestedCategoryId: leafClassification?.nested_sub_category_id,
      briefContextId: contextId,
      eventSource: source || '',
      variant,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Typography size="b_sm" color="grey_900">
      <AppI18n k="sections.metadata.not_sure_description" />
    </Typography>
  );
};
